import { render } from "./ChangePassword.vue?vue&type=template&id=2c19146e"
import script from "./ChangePassword.vue?vue&type=script&lang=ts"
export * from "./ChangePassword.vue?vue&type=script&lang=ts"
script.render = render

export default script